import http from '@/support/plugin/axios'

export const 

//Pegar banners
getMenuBannersById = (companyId) => http.get(`companies/${companyId}/menu-banners`)

//Ofertas especiais
// getPendingPrizesByCompanyIdAndCurrentContactId = ( companyId ) => http.get(`companies/${companyId}/contacts/current/prizes/pending`),

//Recompensas
// getLoyaltyPrizesByCompanyIdAndCurrentContactId = ( companyId ) => http.get(`companies/${companyId}/contacts/current/loyalty/prizes`)